// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legendExample {
  margin: 0 auto;
}

.legendExample > div {
  margin: 10px;
}

.components {
  display: flex;
}

.components > div:last-child {
  flex: 1;
  margin-left: 20px;
}`, "",{"version":3,"sources":["webpack://./src/examples/auxiliary/bullet-legend/legend-stacked-bar-donut/styles.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,iBAAiB;AACnB","sourcesContent":[".legendExample {\n  margin: 0 auto;\n}\n\n.legendExample > div {\n  margin: 10px;\n}\n\n.components {\n  display: flex;\n}\n\n.components > div:last-child {\n  flex: 1;\n  margin-left: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"legendExample": `legendExample`,
	"components": `components`
};
export default ___CSS_LOADER_EXPORT___;
